const activityStyle = () => ({
	datePicker: {
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'&:nth-child(2)': {
			marginLeft: 4,
		},
		'& .MuiFormControl-root': {
			marginBottom: 8,
		},
	},
});

export default activityStyle;
